import { render, staticRenderFns } from "./ExceptionsModal.vue?vue&type=template&id=40ee6b8a&"
import script from "./ExceptionsModal.vue?vue&type=script&lang=js&"
export * from "./ExceptionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports